module.exports = __webpack_public_path__ + "static/krasia-attacks-804d900fa0a27fab68191d964418b1e5.jpg";